import { indexToLocation, locationToString, prettyLineAt } from './location';
import { red, yellow } from './output';
export const syntaxError = (parser, message) => {
    return { expected: [], got: parser.tokens[parser.pos], message };
};
export const prettyLexerError = (token) => {
    return colorError(`lexer error: ${token.kind} token \`${token.value}\``);
};
export const prettySyntaxError = (error) => {
    const msg = error.message ?? `expected \`${error.expected.join(', ')}\``;
    return colorError(`syntax error: ${msg}, got \`${error.got.kind}\``);
};
export const colorError = (message) => {
    return red(message);
};
export const colorWarning = (message) => {
    return yellow(message);
};
export const prettySourceMessage = (message, span, source, notes = []) => {
    const start = indexToLocation(span.start, source.code);
    const locationStr = `${source.filepath}:${locationToString(start)}`;
    const locationMsg = `  at ${locationStr}`;
    const notesStr = notes.length > 0 ? notes.map(n => `  note: ${n}`).join('\n') : '';
    return [message, locationMsg, prettyLineAt(span, source), notesStr].filter(s => s.length > 0).join('\n');
};
//# sourceMappingURL=error.js.map